import { ScrollView } from 'react-native';

import styles from './styles';

export function Container({ children }) {
  return <ScrollView style={styles.container}>{children}</ScrollView>;
}
